module.exports = __webpack_public_path__ + "static/media/7-AirHeatExchanger - Water cool - El heat.c417704a.png";